<template>
  <section class="project-section">
    <header class="section-header">
      <h3 class="section-title">{{ $t('Projects.New project popup.Section_info_title') }}</h3>
      <p class="section-description">{{ $t('Projects.New project popup.Section_info_description') }}</p>
    </header>

    <div class="form-grid">
      <div class="grid grid-cols-12 gap-4">
        <BaseInput
          id="new-project-title"
          data-cy="project-title-input"
          :modelValue="title"
          @update:modelValue="updateTitle"
          :label="$t('Projects.New project popup.Label01')"
          :autoFocus="true"
          :validationMessage="validationErrors?.title"
          class="col-span-8"
        />
        <BaseInput
          id="new-project-number"
          data-cy="project-number-input"
          :modelValue="projectNumber"
          @update:modelValue="updateProjectNumber"
          :label="$t('Projects.New project popup.Label03')"
          ref="projectNumber"
          class="col-span-4"
        />
      </div>

      <BaseSelect
        id="project-group-select"
        data-cy="project-folder-select"
        :modelValue="folderId"
        @update:modelValue="updateFolderId"
        :options="folderOptions"
        :label="$t('Projects.New project popup.Label04')"
        :placeholder="$t('Projects.New project popup.Label04')"
        :customArrow="true"
      />

      <BaseInput
        v-if="folderId === 'new'"
        id="new-project-group"
        data-cy="project-folder-title-input"
        :modelValue="folderTitle"
        @update:modelValue="updateFolderTitle"
        :label="$t('Projects.New project popup.Placeholder01')"
        :validationMessage="validationErrors?.folderTitle"
      />

      <div>
        <BaseSelect
          id="project-country-select"
          data-cy="project-country-select"
          :modelValue="countryId"
          @update:modelValue="updateCountryId"
          :options="countryOptions"
          :label="$t('Projects.New project popup.Select_country_label')"
          :placeholder="$t('Projects.New project popup.Select_country_placeholder')"
          :customArrow="true"
        />
        <p v-if="validationErrors?.countryId" data-cy="validation-error" class="validation-error">
          {{ validationErrors.countryId }}
        </p>
      </div>

      <BaseTextarea
        id="new-project-description"
        data-cy="project-description-input"
        :modelValue="description"
        @update:modelValue="updateDescription"
        :label="$t('Projects.New project popup.Label02')"
      />
    </div>
  </section>
</template>

<script>
import BaseTextarea from '@/components/shared/BaseTextarea'
import BaseInput from '@/components/shared/BaseInput'
import BaseSelect from '@/components/shared/BaseSelect'

export default {
  components: {
    BaseInput,
    BaseTextarea,
    BaseSelect,
  },
  props: {
    title: {
      type: [String, null],
      required: true,
    },
    description: {
      type: [String, null],
      required: true,
    },
    projectNumber: {
      type: [String, null],
      required: true,
    },
    folderId: {
      type: [Number, String, null],
      required: true,
    },
    folderTitle: {
      type: [String, null],
      required: true,
    },
    countryId: {
      type: [Number, null],
      required: true,
    },
    folderOptions: {
      type: Array,
      required: true,
    },
    countryOptions: {
      type: Array,
      required: true,
    },
    validationErrors: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: [
    'update:title',
    'update:description',
    'update:projectNumber',
    'update:folderId',
    'update:folderTitle',
    'update:countryId',
  ],
  methods: {
    updateTitle (val) {
      console.log('updateTitle', val)
      this.$emit('update:title', val)
    },
    updateDescription (val) {
      this.$emit('update:description', val)
    },
    updateProjectNumber (val) {
      this.$emit('update:projectNumber', val)
    },
    updateFolderId (val) {
      this.$emit('update:folderId', val)
    },
    updateFolderTitle (val) {
      this.$emit('update:folderTitle', val)
    },
    updateCountryId (val) {
      console.log('updateCountryId', val)
      this.$emit('update:countryId', val)
    },
  },
}
</script>

<style scoped>
.project-section {
  @apply py-2;
}

.section-header {
  @apply mb-6;
}

.section-title {
  @apply text-xl font-semibold text-gray-800 mb-2;
}

.section-description {
  @apply text-gray-500 leading-relaxed;
}

.form-grid {
  @apply flex flex-col gap-5;
}

.validation-error {
  @apply text-red-500 text-xs mt-1 flex items-center gap-2;
}

.validation-error::before {
  content: '';
  @apply w-1 h-1 rounded-full bg-red-500;
}
</style>
